import React, { Fragment } from "react";
import CustomSectionField from "./CustomSectionField";

const EmployeeCustomSection = ({ section, updateSection }) => {
	const onUpdateField = (fieldToUpdate) => {
		const sectionToUpdate = { ...section };
		const fieldsToUpdate = [...sectionToUpdate.fields];
		const idx = fieldsToUpdate.findIndex((f) => f.id === fieldToUpdate.id);
		if (idx !== -1) {
			fieldsToUpdate[idx] = fieldToUpdate;
		}

		sectionToUpdate.fields = fieldsToUpdate;
		updateSection(sectionToUpdate);
	}

	return (
		<Fragment>
			{section.fields.map((field) => {
				return (
					<CustomSectionField
						field={field}
						updateField={(fieldToUpdate) => {
							onUpdateField(fieldToUpdate);
						}}
					/>
				)
			})}
		</Fragment>
	);
};

export default EmployeeCustomSection;
